import Reveal from "@/components/landing/Reveal";
import { ArrowUpRight } from "lucide-react";

const socials = [
  { name: "Instagram", handle: "@vacansee.official", url: "https://instagram.com" },
  { name: "Twitter / X", handle: "@vacansee_travel", url: "https://x.com" },
  { name: "LinkedIn", handle: "in/rknettem", url: "https://www.linkedin.com/in/rknettem" },
  { name: "Substack", handle: "The Unhurried Gazette", url: "https://substack.com" },
];

export default function Contact() {
  return (
    <footer id="contact" data-testid="contact-section" className="bg-navy text-[#EAE5DC] pt-24 sm:pt-32 pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <Reveal>
          <p data-testid="contact-eyebrow" className="font-mono text-xs uppercase tracking-[0.3em] text-bronze mb-6">
            Contact
          </p>
          <h2 data-testid="contact-heading" className="font-serif text-[13vw] sm:text-7xl lg:text-8xl font-medium tracking-tight leading-[0.95]">
            Let&rsquo;s <span className="italic text-bronze">Connect</span>
          </h2>
        </Reveal>

        <Reveal delay={0.1} className="mt-10">
          <a
            href="mailto:rknettem95@gmail.com"
            data-testid="contact-email-link"
            className="link-underline inline-flex items-center gap-3 font-serif italic text-2xl sm:text-4xl text-[#EAE5DC] hover:text-bronze transition-colors duration-300"
          >
            rknettem95@gmail.com
            <ArrowUpRight className="h-6 w-6 sm:h-8 sm:w-8" />
          </a>
          <p className="mt-4 max-w-md text-sm sm:text-base font-light text-[#EAE5DC]/60 leading-relaxed">
            Press, partnerships, hiring partners, and early access enquiries — we reply within one working day.
          </p>
        </Reveal>

        <Reveal delay={0.15} className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10">
          {socials.map((s) => (
            <a
              key={s.name}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`social-link-${s.name.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className="group bg-navy px-6 py-7 transition-colors duration-300 hover:bg-navy-card"
            >
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#EAE5DC]/50 mb-2">{s.name}</p>
              <p className="flex items-center gap-1.5 text-sm sm:text-base font-medium">
                {s.handle}
                <ArrowUpRight className="h-3.5 w-3.5 opacity-0 -translate-x-1 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0 text-bronze" />
              </p>
            </a>
          ))}
        </Reveal>

        <div className="mt-16 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-white/10 pt-8">
          <p className="font-serif text-xl font-semibold">
            Vacansee<span className="text-bronze">.</span>
          </p>
          <p data-testid="footer-copyright" className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.2em] text-[#EAE5DC]/40">
            © 2026 Vacansee · Hiring, Reimagined · Coming Soon
          </p>
        </div>
      </div>
    </footer>
  );
}
